export const environment = {
  production: true,
  urlbase: '/',
  auth: 'keycloak',
  backend: 'real',
  grafana: 'https://grafana.getronettes.getronicssmartspaces.com/grafana',
  site: 'demo',
  keycloak: {
    'url': 'https://getronettes.getronicssmartspaces.com/auth',
    'realm': 'Boustead-Dev',
    'clientId': 'empusa',
  },
  //the currency used
  currency: 'S$',
  show_acess_group: false
};
